var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video", class: { has_border: _vm.has_border === "Yes" } },
    [
      _c("div", { staticClass: "play_button", on: { click: _vm.modalOpen } }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "30",
              height: "40",
              viewBox: "0 0 30 40",
            },
          },
          [
            _c("path", {
              attrs: {
                id: "Polygon_1",
                "data-name": "Polygon 1",
                d: "M20,3.606,3.737,28H36.263L20,3.606M20,0,40,30H0Z",
                transform: "translate(30) rotate(90)",
                fill: "#fff",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.video_poster
        ? _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.video_poster,
                expression: "video_poster",
              },
            ],
            staticClass: "video_poster",
            class: { has_border: _vm.has_border === "Yes" },
            attrs: { alt: "video_poster" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          class: { open: _vm.isModalOpen == true },
          on: { click: _vm.modalClose },
        },
        [
          _vm.isModalOpen === true
            ? _c("div", { staticClass: "iframe__container" }, [
                _c(
                  "div",
                  { staticClass: "close_image", on: { click: _vm.modalClose } },
                  [_c("close-button", { attrs: { type: "grey" } })],
                  1
                ),
                _vm._v(" "),
                _c("iframe", {
                  staticClass: "responsive__iframe",
                  attrs: {
                    src: _vm.video_source + _vm.setAutoplay,
                    frameborder: "0",
                    allow:
                      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: "",
                  },
                }),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }